<template>
  <div id="home" v-if="storeConfig.hasHomePage">
    <template v-for="(element, elementIndex) in elements">
      <SfHero
        class="hero"
        v-if="element.type === 'banners'"
        :key="elementIndex"
      >
        <SfHeroItem
          v-for="(img, index) in element.data"
          :key="index"
          :image="img.image"
          :title="img.title"
          :button-text="img.buttonText"
          :button-link="img.link"
          :background="img.background"
          :class="img.className"
        >
        </SfHeroItem>
      </SfHero>
      <SfSection
        v-if="element.type === 'categoryGroup' && element.categories.length"
        :title-heading="element.title"
        :key="elementIndex"
      >
        <CategoryGrid
          class="banner-grid"
          :categories="element.categories"
          @click="toCategory"
        ></CategoryGrid>
      </SfSection>
      <SfSection
        v-if="element.type === 'products' && element.products.length"
        :title-heading="element.title"
        :key="elementIndex"
      >
        <div class="products" v-if="!isGroupedView">
          <transition-group
            appear
            name="products__slide"
            tag="div"
            class="products__grid"
          >
            <ProductGridItem
              v-for="(product, index) in element.products"
              :key="product.id"
              :style="{ '--index': index }"
              :product="product"
              :is-cart-enabled="isCartEnabled"
              :show-stock-errors="showStockErrors"
              class="products__grid-item"
            />
          </transition-group>
        </div>
        <div class="products" v-else>
          <transition-group
            appear
            name="products__slide"
            tag="div"
            class="products__grid"
          >
            <CollectedProductGridItem
              v-for="(group, i) in element.products"
              :key="group[0].itemId"
              :style="{ '--index': i }"
              :products="group"
              :is-cart-enabled="isCartEnabled"
              :show-stock-errors="showStockErrors"
              class="products__grid-item"
            />
          </transition-group>
        </div>
        <!-- <SfCarousel class="carousel">
          <SfCarouselItem
            v-for="(product, index) in element.products"
            :key="index"
            class="carousel__item"
          >
            <ProductGridItem
              :style="{ '--index': index }"
              :product="product"
              class="products__product-card"
            />
          </SfCarouselItem>
        </SfCarousel> -->
      </SfSection>
    </template>
    <SfSection>
      <SfButton
        class="sf-button--full-width color-secondary cart-action"
        style="max-width: 400px; margin: 0 auto;"
        @click.native="startShopping"
      >
        {{ $t("Start shopping") }}
      </SfButton>
    </SfSection>
  </div>
</template>
<script>
import {
  SfButton,
  SfHero,
  SfBannerGrid,
  SfBanner,
  SfCallToAction,
  SfSection,
  SfCarousel,
  SfProductCard,
  SfImage,
} from "@lib/components";
import CategoryGrid from "@lib/components/organisms/CategoryGrid";
import ProductGridItem from "@lib/components/organisms/ProductGridItem";
import CollectedProductGridItem from "@lib/components/organisms/CollectedProductGridItem";
import { mapGetters, mapActions } from "vuex";

const colorToBackgroundMap = {
  red: "rgba(256,0,0,0.2)",
  blue: "rgba(0, 0, 256, 0.2)",
  brown: "rgba(181,101,29,0.4)",
  green: "rgba(0,256,0,0.1)",
  orange: "rgba(256,128,0,0.5)",
};

const getGroupedProducts = (products) => {
  let groups = {};
  for (let product of products) {
    groups[product.itemId] = groups[product.itemId] || [];
    groups[product.itemId].push(product);
  }
  return Object.values(groups);
};

export default {
  name: "Home",
  components: {
    SfButton,
    SfHero,
    SfBannerGrid,
    SfBanner,
    SfCallToAction,
    SfSection,
    SfCarousel,
    SfProductCard,
    SfImage,
    CategoryGrid,
    ProductGridItem,
    CollectedProductGridItem,
  },
  data() {
    return {
      headingTitle: {
        mobile: "Match it with",
        desktop: "Bestsellers",
      },
      heroes: [
        {
          image:
            "https://storybook.storefrontui.io/assets/storybook/Home/hero.png",
          background: "rgb(236, 239, 241)",
          title: "Colorful summer dresses are now in stock!",
          link: {
            type: "url",
            value: "https://google.com",
          },
          buttonText: "Shop Now",
        },
        {
          image:
            "https://media.istockphoto.com/photos/fresh-white-farm-eggs-in-a-bowl-on-blue-wooden-table-with-copy-space-picture-id1187285739?k=6&m=1187285739&s=612x612&w=0&h=oR34pNrCdIXfQf9Y0Q8ps_dsRc7H810DfbRQv2irnww=",
          background: "rgb(236, 239, 241)",
          title: "Freshest Eggs and Bread",
          link: {
            type: "tags",
            value: ["tag1", "tag2"],
          },
          buttonText: "Shop Now",
        },
        {
          image:
            "https://storybook.storefrontui.io/assets/storybook/Home/hero.png",
          background: "rgb(236, 239, 241)",
          title: "Banner Title 3",
          link: {
            type: "categories",
            value: ["cat1", "cat2"],
          },
          buttonText: "Shop now",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      storeConfig: "store",
      productList: "catalog/list",
      categoryList: "catalog/categoryBannerInfo",
    }),
    isCartEnabled() {
      return (
        this.storeConfig.orderConfig.orderEnabled ||
        this.storeConfig.orderConfig.enquiryEnabled
      );
    },
    showStockErrors() {
      return !this.storeConfig.orderConfig.allowOrderOnNoStock;
    },
    isGroupedView() {
      return (
        this.storeConfig.catalogConfig &&
        this.storeConfig.catalogConfig.enableVariantGrouping
      );
    },
    elements() {
      if (!this.storeConfig.homePageConfig) return null;
      const elements = [];
      const config = this.storeConfig.homePageConfig;
      for (let configItem of config.data) {
        const configElement = null;
        if (configItem.type === "banners") {
          configElement = { ...configItem };
        } else if (configItem.type === "categoryGroup") {
          let categoryData = [];
          if (configItem.categoryIds && configItem.categoryIds.length) {
            for (let catId of configItem.categoryIds) {
              let category = this.categoryGridMap[catId];
              if (category) {
                categoryData.push(category);
              }
            }
          } else {
            categoryData = this.categoryGridData;
          }
          configElement = { ...configItem, categories: categoryData };
        } else if (configItem.type === "products") {
          const enabledTags = configItem.selectionCriteria.tags || [];
          const enabledCategories =
            configItem.selectionCriteria.categories || [];
          let products = [];
          if (enabledTags.length) {
            const enabledProducts = this.productList.filter((p) => {
              return enabledTags.some(
                (tag) => p.tags && p.tags.length && p.tags.includes(tag)
              );
            });
            products = products.concat(enabledProducts);
          }
          if (enabledCategories.length) {
            const enabledProducts = this.productList.filter((p) => {
              return enabledCategories.some((catId) => p.categoryId === catId);
            });
            products = products.concat(enabledProducts);
          }
          configElement = {
            ...configItem,
            products: this.isGroupedView
              ? getGroupedProducts(products)
              : products,
          };
        }
        if (configElement) elements.push(configElement);
      }
      return elements;
    },
    categoryGridData() {
      return this.categoryList.map((x) => {
        return {
          ...x,
          buttonText: "Shop Now",
          backgroundColor: colorToBackgroundMap[x.colour] || "#999999",
        };
      });
    },
    categoryGridMap() {
      return this.categoryGridData.reduce((map, category) => {
        map[category.id] = category;
        return map;
      }, {});
    },
  },
  beforeMount() {
    if (!this.$store.state.store.hasHomePage) {
      this.$router.replace({ name: "catalog" });
    } else {
      this.fetchProducts();
    }
  },
  methods: {
    ...mapActions({
      fetchProducts: "catalog/fetch",
    }),
    toggleWishlist(index) {
      return (this.products[index].isOnWishlist = !this.products[index]
        .isOnWishlist);
    },
    toCategory(catId) {
      this.$router.push({
        name: "catalog",
        params: { categoryId: catId },
      });
    },
    getCategoryGridData(catIds) {
      let categoryData = [];
      for (let catId of catIds) {
        let category = this.categoryGridMap[catId];
        if (category) {
          categoryData.push(category);
        }
      }
      return categoryData;
    },
    startShopping() {
      this.$router.push({
        name: "catalog",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@lib/styles";
#home {
  box-sizing: border-box;
  padding: 0 var(--spacer-sm);
  margin-top: 1.5rem;
  --section-margin: var(--spacer-lg) 0;
  --section-content-margin: 0 0 var(--spacer-lg) 0;
  @include for-desktop {
    padding: 0 var(--spacer-sm);
    max-width: 1272px;
    margin: 0 auto;
    margin-top: 3rem;
    --section-margin: var(--spacer-lg) 0;
    --section-content-margin: 0 0 var(--spacer-lg) 0;
  }
}
.carousel {
  margin: 0 calc(var(--spacer-sm) * -1) 0 0;
  @include for-desktop {
    margin: 0;
  }
  // todo: fix product shadow on carousel
}
.banner-grid {
  margin: var(--spacer-base) 0;
  @include for-desktop {
    margin: var(--spacer-2xl) 0;
  }
}
.call-to-action {
  display: flex;
}
.instagram-grid {
  max-width: 60rem;
  margin: 0 auto;
  &__row {
    display: flex;
    & + & {
      margin: var(--spacer-xs) 0 0 0;
      @include for-desktop {
        margin: calc(var(--spacer-xl) / 2) 0 0 0;
      }
    }
  }
  &__col {
    flex: 1;
    margin: 0;
    & + & {
      margin: 0 0 0 var(--spacer-xs);
      @include for-desktop {
        margin: 0 0 0 calc(var(--spacer-xl) / 2);
      }
    }
  }
}
.app-banner {
  --banner-container-width: 100%;
  --banner-title-margin: var(--spacer-base) 0 var(--spacer-xl) 0;
  --banner-padding: 0 var(--spacer-2xl);
  --banner-title-font-size: var(--h1-font-size);
  --banner-subtitle-font-size: var(--font-xl);
  --banner-title-font-weight: var(--font-semibold);
  --banner-subtitle-font-weight: var(--font-medium);
  --banner-title-text-transform: capitalize;
  --banner-subtitle-text-transform: capitalize;
  display: block;
  min-height: 26.25rem;
  max-width: 65rem;
  margin: 0 auto;
  padding: 0 calc(25% + var(--spacer-2xl)) 0 var(--spacer-xl);
  &__call-to-action {
    --button-background: transparent;
    display: flex;
  }
  &__button {
    --image-width: 8.375rem;
    --image-height: 2.75rem;
    --button-padding: 0;
    & + & {
      margin: 0 0 0 calc(var(--spacer-xl) / 2);
    }
  }
}

.products {
  box-sizing: border-box;
  flex: 1;
  margin: 0;
  &__grid {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    &-item {
      box-sizing: border-box;
      display: flex;
      flex: 0 1 50%;

      @include for-desktop {
        flex: 0 1 25%;
      }
    }

    @include for-desktop {
      padding: var(--spacer-xs);
    }
  }
}
</style>
